"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isOpenBook;
exports.isClosedBook = isClosedBook;
function isOpenBook(quizType) {
  return ['study', 'tutor', 'search'].includes(quizType);
}
function isClosedBook(quizType) {
  return !isOpenBook(quizType);
}